export enum CalculatorEvents {
  CONTINUE = 'continue',
  SAVE = 'save',
  HAS_NEW_CALCULATION = 'has new calculation',
}

export default CalculatorEvents;
